export default __webpack_public_path__ + "static/media/site.78ed1dc2.png";